export class ProjectAnalysis1075Layout {
	public sections = [
		{
			title: 'Analysis',
			items: [
				[
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisBudgetAnalyzedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisBudgetAnalysisComment'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisAdditionalFacilitiesFeeIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path:
								'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisAdditionalFacilitiesFeeDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisCompetitiveProjectComparisonType',
							show: {
								value: true,
								label: true
							}
						}
					},
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							label: 'If High or Low, describe',
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisCompetitiveProjectComparisonDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisSpecialCharacteristicsIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisSpecialCharacteristicsDescription'
						}
					}
				]
			]
		},
		{
			title: 'Condo Market Conditions',
			items: [
				[
					{
						cssClass: 'col-sm-12',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Inventory Analysis' },
								{ label: 'Prior 7-12 Months' },
								{ label: 'Prior 4-6 Months' },
								{ label: 'Current 3 Months' },
								{ label: 'Overall Trend' }
							],
							rows: [
								{
									cols: [
										{
											options: { label: 'Comparable Settled Sales' }
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalSalesPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalSalesPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalSalesLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalSalesOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: { label: 'Absorption Rate (Total Sales / Months)' }
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketAbsorptionRatePrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketAbsorptionRatePrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketAbsorptionRateLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketAbsorptionRateOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: { label: 'Comparable Active Listings' }
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalListingsPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalListingsPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalListingsLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketTotalListingsOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: {
												label: 'Months of Housing Supply (Total Listings / Absorption Rate)'
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketSupplyPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketSupplyPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketSupplyLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													'CV_EXTENSION_SECTION.FIELDS.CVSubjectProjectMarketSupplyOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				],
				[
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSubjectProjectName'
						}
					},
					{
						cssClass: 'col-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSubjectTrendsForeclosureActivityIndicator',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSubjectTrendsReconciliationComment'
						}
					}
				]
			]
		}
	];
}
